import { useNavigate } from "react-router-dom";
import { useMaintenanceCommand } from "./hooks/useMaintenanceCommand.js";
import { ROUTES } from "../../core/routes/routes.js";
import FormMaintenance from "./components/FormMaintenance.jsx";

function RegisterMaintenance() {
  const navigate = useNavigate();
  const {
    maintenance,
    handleChange,
    errors: { errors },
    createMaintenance,
    updateMaintenance,
  } = useMaintenanceCommand();

  const handleSubmit = async () => {
    let success = false;
    if (maintenance.id) {
      success = await updateMaintenance();
    } else {
      success = await createMaintenance();
    }
    
    // Si el guardado fue exitoso, redirigir a la lista
    if (success) {
      navigate(ROUTES.LIST_MAINTENANCE);
    }
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar mantenimiento</h1>
      </header>
      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de mantenimiento. Asegúrate de completar
              todos los campos requeridos.
            </p>
            <FormMaintenance
              maintenance={maintenance}
              onChange={handleChange}
              onSubmit={handleSubmit}
              errors={errors}
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterMaintenance;
